import { useAutoGrow as e } from "../hooks/useAutoGrow.mjs";
import { Field as t } from "./ComposerField.styled.mjs";
import { forwardRef as n, useImperativeHandle as r, useRef as i } from "react";
import { jsx as a } from "react/jsx-runtime";
//#region src/components/Composer/components/ComposerField.tsx
var o = n(({ rows: n = 1, value: o, ...s }, c) => {
	let l = i(null);
	return r(c, () => l.current), e(l, o), /* @__PURE__ */ a(t, {
		ref: l,
		rows: n,
		value: o,
		autoComplete: "off",
		...s
	});
});
o.displayName = "Composer.Field";
//#endregion
export { o as ComposerField };
